import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { CmsService, OccConfig } from '@spartacus/core';
//import { WebtrekkSmartPixelAngular } from '@webtrekk-smart-pixel/angular';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { map, switchMap, take, takeUntil } from 'rxjs/operators';
import { GetDocumentService } from 'src/app/customServices/get-document.service';
import { BannerWebtrekkTrackingService } from './bannerWebtrekkTrackingService';

@Component({
  selector: 'app-rotating-banner',
  templateUrl: './rotating-banner.component.html',
  styleUrls: ['./rotating-banner.component.scss'],
  standalone: false
})
export class RotatingBannerComponent {
  bannarImages: any;
  componentId: string;
  url: any;
  baseUrl: string = this.config?.backend?.occ?.baseUrl + '/';
  BannerUrls: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 20000,
    speed: 2000,
    pauseOnHover: true,
    arrows: true,
    nextArrow: "<div class='slick-nextt'><span class='icon-right-arrow-blue'></span></div>",
    prevArrow: "<div class='slick-prevv'><span class='icon-right-arrow-blue'></span></div>",
  };

  actionName: string;
  private destroy$ = new Subject<void>();
  constructor(
    private cmsService: CmsService,
    private http: HttpClient,
    //private pixel: WebtrekkSmartPixelAngular,
    private config: OccConfig,
    private documentService: GetDocumentService,
    private bannerwebtrekkTrackingService: BannerWebtrekkTrackingService
  ) {
    // this.pixel.action({});
  }
  documentUrlsMap: { [key: string]: Observable<string> } = {};
  ngOnInit(): void {
    this.cmsService
      .getComponentData('HomepageBannerCarouselComponent')
      .pipe(
        take(1),
        switchMap((data: any) => {
          const componentId = data.banners.trim().split(' ').join('%2C');
          return this.getComponentData(componentId);
        }),
      )
      .subscribe((data: any) => {
        this.url = data.component;
        this.handleApiResponse();
      });
    this.BannerUrls.pipe(takeUntil(this.destroy$)).subscribe((banners) => {
      banners.forEach((slide) => {
        if (!this.documentUrlsMap[slide.url]) {
          this.documentUrlsMap[slide.url] = this.getDocumnet(slide, slide.urlLink);
        }
      });
    });
  }

  webtrekk_click(name) {

    this.bannerwebtrekkTrackingService.trackAction(name);
    /*  this.pixel.action({ name: this.actionName });
     this.pixel.trackAction(true); */
  }

  getComponentData(componentId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}occ/v2/NA/cms/kbcomponents?fields=DEFAULT&componentIds=${componentId}`);
  }

  handleApiResponse(): void {
    if (this.url) {
      this.BannerUrls.next(
        this.url.map((item) => {
          const x = { url: item.media.url, urlLink: item.urlLink, code: item.media.code };
          return x;
        })
      );
    } else {
      console.error('apiResponse is undefined or null.');
    }
  }
  getDocumnet(slide: any, str: string): Observable<string> {
    if (slide.code === 'Banner-ADBCaliperAndRotors.png') {
      return this.documentService.getDocumentByDocumentCode('BW7579').pipe(
        map((response: { url: string }) => response.url)
      );
    } else if (slide.code === 'bendix-homepage-banner2a.jpg') {
      return this.documentService.getDocumentByDocumentCode('BW2297').pipe(
        map((response: { url: string }) => response.url)
      );
    }
    return of(str);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
